<template>
    <div aria-hidden="true" class="relative flex items-center">
        <div class="p-0 absolute overflow-hidden z-1 text-warning" :style="`width: ${percentage}%;`">
            <MiscIcon name="stars-filled" class="max-w-none" :style="`width: ${width}px; height: ${height}px;`" />
        </div>
        <MiscIcon name="stars-empty" class="block max-w-none text-transparent" :style="`width: ${width}px; height: ${height}px;`" />
    </div>
</template>

<script setup lang="ts">
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<{
    percentage: number
    width?: number
    height?: number
}>(), {
    width: 120,
    height: 24
})
</script>
